import { render, staticRenderFns } from "./ResearchPageHeader.vue?vue&type=template&id=4fb803df"
import script from "./ResearchPageHeader.vue?vue&type=script&lang=js"
export * from "./ResearchPageHeader.vue?vue&type=script&lang=js"
import style0 from "./ResearchPageHeader.vue?vue&type=style&index=0&id=4fb803df&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb803df')) {
      api.createRecord('4fb803df', component.options)
    } else {
      api.reload('4fb803df', component.options)
    }
    module.hot.accept("./ResearchPageHeader.vue?vue&type=template&id=4fb803df", function () {
      api.rerender('4fb803df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchPageHeader.vue"
export default component.exports